import {
  Component,
  OnDestroy,
  Input,
  OnInit,
  AfterViewInit
} from '@angular/core';

import { UserAuth } from '@nrwl/common-lib';

@Component({
  selector: 'wizard-users-roles',
  templateUrl: './users.roles.html',
  styleUrls: ['../wizard.user.style.scss'],
  providers: []
})
export class UsersRolesComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() step: any;
  @Input() subStep: any;
  @Input() wizardCtrl: any;

  constructor() {}

  ngOnDestroy() {}

  ngAfterViewInit() {}

  ngOnInit() {
    this.step._returnOutput('roles', this.step.dataSource, null, {
      isChecked: false
    });
  }

  flipValue(member) {
    if (!member.disabled) {
      member.isChecked = !member.isChecked;
    }
    this.step._returnOutput('roles', this.step.dataSource, null, {
      isChecked: true
    });
  }

  clickDetected() {
    return false;
  }
}
